<script>
import DomainCharts from "@views/security/backend/DomainCharts.vue";
import SubdomainChart from "@views/security/backend/SubdomainChart.vue";
import SecurityChart from "@views/security/backend/SecurityChart.vue";
import InterfaceChart from "@views/security/backend/InterfaceChart.vue";
export default {
  name: "Dashboard",
  components: {
    InterfaceChart,
    SecurityChart,
    SubdomainChart,
    DomainCharts,
  },
  data: () => ({
    endpoints: [],
    uriKeywords: '',
    interfaceKeywords: '',
    isSecureKeywords: '',
    domainKeywords: '',
    interfaces: ['api', 'web']
  }),
  computed: {
    filteredEndpoints() {
      return this.endpoints.filter(endpoint => {
        return endpoint.uri.includes(this.uriKeywords)
      }).filter(endpoint => {
        return endpoint.interface.includes(this.interfaceKeywords)
      }).filter(endpoint => {
        return endpoint.is_secure.toString().includes(this.isSecureKeywords)
      })
    }
  },
  async mounted() {
    await this.fetchDashboard()
  },
  methods: {
    async fetchDashboard() {
      this.$vs.loading();
      try {
        const {data} = await axios.get('/api/backoffice/security/backend/dashboard')
        this.endpoints = data;
      } catch (error) {
        this.$vs.notify({
          title: 'Error',
          text: 'Error fetching dashboard data',
          color: 'danger',
          iconPack: 'feather',
          icon: 'icon-alert-circle'
        })
      } finally {
        this.$vs.loading.close();
      }
    }
  }
}
</script>

<template>
  <div class="container mt-5">
    <div class="grid grid-cols-3 gap-2 mb-5">
      <interface-chart :endpoints="endpoints" />
      <security-chart :endpoints="endpoints" />
      <domain-charts :endpoints="endpoints" />
      <subdomain-chart :endpoints="endpoints" />
    </div>

    <vx-card title="Listado de endpoints">
      Endpoints: {{filteredEndpoints.length}}
      <table class="w-full">
        <thead>
        <tr>
          <th>
            <vs-input v-model="uriKeywords"></vs-input>
          </th>
          <th>
            <vs-select v-model="interfaceKeywords">
              <vs-select-item
                  v-for="item in interfaces"
                  :key="item"
                  :value="item"
                  :text="item"></vs-select-item>
            </vs-select>
          </th>
          <th>

          </th>
          <th>
            <vs-select v-model="isSecureKeywords">
              <vs-select-item
                  v-for="item in ['true', 'false']"
                  :key="item"
                  :value="item"
                  :text="item"></vs-select-item>
            </vs-select>
          </th>
        </tr>
        <tr>
          <th>Endpoint</th>
          <th>Interface</th>
          <th>Domain</th>
          <th>Subdomain</th>
          <th>Tiene seguridad</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, i) in filteredEndpoints" :key="i">
          <td class="p-2">
            <span class="bg-primary text-white p-2">{{ item.methods }}</span>
            {{ item.uri }}
          </td>
          <td class="p-2">{{ item.interface }}</td>
          <td class="p-2">{{ item.domain }}</td>
          <td class="p-2">{{ item.subdomain }}</td>
          <td class="p-2">{{ item.is_secure }}</td>
        </tr>
        </tbody>
      </table>
    </vx-card>
  </div>
</template>

<style scoped>

</style>